export function initConfirmRegistrationAndSignup() {
    const confirmRegistrationAndSignupArticle = document.querySelector("[data-confirm-register-and-signup-article]");
    if (!confirmRegistrationAndSignupArticle)
        return;
    console.log(sessionStorage.getItem("verified_at"));
    initInsertVerifiedAt(confirmRegistrationAndSignupArticle);
}
function initInsertVerifiedAt(confirmRegistrationAndSignupArticle) {
    const registerButton = document.querySelector("[data-register-button]");
    if (!registerButton)
        throw new Error("'registerButton' is not found");
    registerButton.addEventListener("click", function () {
        const verifiedAtInputElement = document.querySelector("[data-insert-verified-at]");
        if (!verifiedAtInputElement)
            throw new Error("'verifiedAtInputElement' is not found");
        verifiedAtInputElement.value = sessionStorage.getItem("verified_at");
        sessionStorage.removeItem("verified_at");
    });
}
